import { Accordion } from '../../../../../../common/SharedComponents';
import { IBridgeTableRow } from '../common/constants/tables/interfaces/IBridgeTableRow';
import { ILoanHistorySummaryTableRow } from '../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { BridgeTable } from './components/BridgeTable';
interface BridgeProps {
    bridgeData: IBridgeTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const Bridge: React.FC<BridgeProps> = ({ onLoanSummaryClick, bridgeData }) => {
    return (
        <>
            <Accordion
                title='Bridge'
                isExpanded={true}
                id={`bll_bridge`}
                isCollapsable={true}
            >
                <div
                    className='card'
                    style={{ width: '600px', border: '1px solid gray' }}
                >
                    <div className='card-section'>
                        <BridgeTable
                            onLoanSummaryClick={onLoanSummaryClick}
                            bridgeData={bridgeData}
                        />
                    </div>
                </div>
            </Accordion>
        </>
    );
};
